<div class="card">
    <ng-container *miproLoading="loadingUser">
        <form
            [autoSave]="autoSaveUser"
            [useServerResponse]="false"
            [formGroup]="userForm"
            (ngSubmit)="manualSave()"
            class="m-form">
            <h1>Edit User
                <form-state></form-state>
            </h1>

            <p-messages severity="warn" *ngIf="warningText">
                <ng-template pTemplate="content">
                    <div class="flex flex-column">
                        <div class="flex align-items-center mb-2">
                            <i class="pi pi-clock mr-1"> </i>
                            <b>{{ warningText }}</b>
                        </div>
                    </div>
                </ng-template>
            </p-messages>

            <ng-container *ngIf="enableImpersonateBtn">
                <button
                    pButton
                    type="button"
                    label="Impersonate this user"
                    (click)="impersonate()"
                    [disabled]="savingUser || runningUserAction"></button>
            </ng-container>

            <edit-user-control formControlName="user" [registrationNumberRequired]="prnRequired">
                <ng-container formGroupName="otherFields">
                    <div class="grid col-12">
                        <div class="grid col-12">
                            <div class="col-6">
                                <div class="inputs-group">
                                    <div *ngIf="roleOptionsReadyAndNotEmpty" class="inputs-group-row">
                                        <label class="inputs-group-row-name asterisk-mark">User Types:</label>
                                        <div class="inputs-group-row-value">
                                            <p-multiSelect
                                                [styleClass]="userOrganizationRoles.length ? '' : 'required-field'"
                                                [(ngModel)]="userOrganizationRoles"
                                                [ngModelOptions]="{ standalone: true }"
                                                [options]="roleOptions"
                                                (onChange)="userTypeChanged()"
                                                [ngClass]="{
                                                    'ng-invalid': (isGenericLogin || isClinicalSafetyOfficer) && userOrganizationRoles?.length > 1
                                                }"
                                                placeholder="Select roles"
                                                optionLabel="displayName"
                                                [disabled]="defaultGenericPatient || defaultClinicalSafetyOfficer"
                                                dataKey="id"
                                                name="roles">
                                            </p-multiSelect>
                                            <div class="p-error"
                                                 *ngIf="isGenericLogin && userOrganizationRoles?.length > 1">
                                                <small [style.display]="'block'">
                                                    Generic Logins cannot be used with other User Types
                                                </small>
                                            </div>
                                            <div class="p-error" *ngIf="!validMultipleOrgsRoles">
                                                <small [style.display]="'block'">
                                                    This field is required for all the organisations
                                                </small>
                                            </div>
                                            <div class="p-error"
                                                 *ngIf="isClinicalSafetyOfficer && userOrganizationRoles?.length > 1">
                                                <small [style.display]="'block'">
                                                    Clinical Safety Officer cannot be used with other User Types
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6"
                                 *ngIf="(isGenericLogin || isClinicalSafetyOfficer) && userOrganizationRoles?.length === 1">
                                <div class="inputs-group">
                                    <div class="inputs-group-row">
                                        <label class="inputs-group-row-name asterisk-mark">Username:</label>
                                        <div class="inputs-group-row-value">
                                            <input [formControl]="userName" pInputText/>
                                            <control-errors
                                                [control]="userName"
                                                [errors]="{
                                            pattern:
                                                'Only letters, digits or special characters <chars-allowed>-._@+</chars-allowed> are allowed'
                                        }"></control-errors>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid col-12">
                            <div class="col-6">
                                <div class="inputs-group">
                                    <div class="inputs-group-row">
                                        <label *ngIf="multipleOrganizations" class="inputs-group-row-name">
                                            <naming-convention-label [type]="'Org'"
                                                                     [singular]="false"></naming-convention-label>
                                            :
                                        </label>
                                        <label *ngIf="userAccesses.length === 1" class="inputs-group-row-name">
                                            <naming-convention-label [type]="'Org'"
                                                                     [singular]="true"></naming-convention-label>
                                            :
                                        </label>
                                        <div class="inputs-group-row-value">
                                            <p-dropdown
                                                *ngIf="multipleOrganizations"
                                                [ngModel]="currentUserAccess"
                                                (ngModelChange)="onCurrentUserAccessChange($event)"
                                                [ngModelOptions]="{ standalone: true }"
                                                optionLabel="organization.name"
                                                [options]="userAccesses"
                                                dataKey="organization.id"
                                                appendTo="body"
                                                name="organization">
                                            </p-dropdown>
                                            <div [style.padding-top]="'0.6875rem'" *ngIf="userAccesses.length === 1">
                                                {{ currentUserAccess.organization.name }}
                                            </div>
                                            <p-button *ngIf="multipleOrganizations" styleClass="p-button-sm"
                                                      (onClick)="unlinkOrganization()">
                                                <div class="flex justify-content-center" [style.width]="'100%'">
                                                    <i class="pi pi-trash" [style.padding-right]="'5px'"></i>
                                                    Remove
                                                </div>
                                            </p-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" *ngIf="!isGenericLogin && !isClinicalSafetyOfficer">
                                <div class="inputs-group">
                                    <div class="inputs-group-row">
                                        <label for="permissions"
                                               class="inputs-group-row-name asterisk-mark">Permissions:</label>
                                        <div class="inputs-group-row-value">
                                            <p-multiSelect
                                                #userPermissionsMultiselect
                                                *miproLoading="permissionsLoading"
                                                [styleClass]="userOrganizationPermissions?.length ? '' : 'required-field'"
                                                [(ngModel)]="userOrganizationPermissions"
                                                [ngModelOptions]="{ standalone: true }"
                                                [options]="permissionOptions"
                                                (onChange)="onUserPermissionChange($event)"
                                                placeholder="Select permissions"
                                                optionLabel="name"
                                                dataKey="id"
                                                id="permissions"
                                                name="permissions">
                                            </p-multiSelect>
                                            <p-button *ngIf="!isGenericLogin && !isClinicalSafetyOfficer &&
                                              !isGoverningBodyAdmin && userOrganizationRoles?.length > 0"
                                                      styleClass="p-button-sm"
                                                      (onClick)="setDefaultPermissions(true)">
                                                <div class="flex justify-content-center" [style.width]="'100%'">
                                                    <i class="pi pi-refresh" [style.padding-right]="'5px'"></i>
                                                    Reset Default Permissions
                                                </div>
                                            </p-button>
                                            <div class="p-error" *ngIf="!validMultipleOrgsPermissions">
                                                <small [style.display]="'block'">
                                                    This field is required for all the organisations
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </edit-user-control>

            <form-buttons
                [saving]="savingUser"
                [config]="buttonsConfig"
                [disabled]="!isValid || runningUserAction || ((isGenericLogin || isClinicalSafetyOfficer) && userOrganizationRoles?.length > 1)">
                <button
                    *ngIf="!isGenericLogin && !isClinicalSafetyOfficer"
                    type="button"
                    pButton
                    label="Add {{ namingConvService.organisationSingular }}"
                    [disabled]="savingUser || runningUserAction"
                    (click)="displayAddOrganization = true"></button>
                <button
                    *ngIf="enableResendInvitationBtn"
                    type="button"
                    pButton
                    label="Resend invitation"
                    [disabled]="savingUser || runningUserAction"
                    (click)="resendInvitation()"></button>
                <button
                    *ngIf="enableResendEmailConfirmationBtn"
                    type="button"
                    pButton
                    label="Send email confirmation"
                    [disabled]="savingUser || runningUserAction"
                    (click)="resendEmailConfirmation()"></button>
                <button
                    *ngIf="enableSendPasswordResetMailBtn"
                    type="button"
                    pButton
                    label="Password reset"
                    [disabled]="savingUser || runningUserAction"
                    (click)="sendPasswordResetMail()"></button>
                <button *ngIf="allowedToReset2Fa" type="button" pButton label="Reset 2FA"
                        (click)="reset2FaConfirmation()"></button>
                <button
                    *ngIf="enableSendPinResetMailBtn"
                    type="button"
                    pButton
                    label="Offline PIN reset"
                    [disabled]="savingUser || runningUserAction"
                    (click)="sendOfflinePinResetMail()"></button>
                <button
                    *ngIf="enableApproveBtn"
                    type="button"
                    pButton
                    label="Approve"
                    [disabled]="savingUser || runningUserAction"
                    class="p-button-success"
                    (click)="approve()"></button>
                <button
                    *ngIf="enableSuspendBtn || enableUnsuspendBtn"
                    type="button"
                    pButton
                    [label]="enableSuspendBtn ? 'Suspend' : 'Unsuspend'"
                    [disabled]="savingUser || runningUserAction"
                    [ngClass]="enableSuspendBtn ? 'p-button-danger' : 'p-button-success'"
                    (click)="toggleLocking()"></button>
                <button
                    *ngIf="enableDeleteBtn || enableRestoreBtn"
                    type="button"
                    pButton
                    [label]="enableDeleteBtn ? 'Delete' : 'Restore'"
                    [disabled]="savingUser || runningUserAction"
                    (click)="toggleDeleting()"></button>
            </form-buttons>
        </form>
    </ng-container>
</div>

<p-dialog
    [(visible)]="displayAddOrganization"
    [modal]="true"
    [draggable]="false"
    [style]="{ 'max-width': '600px', width: '100%' }"
    header="Add {{ namingConvService.organisationSingular }}">
    <div class="inputs-group-row">
        <label class="inputs-group-row-name asterisk-mark">
            <naming-convention-label [type]="'Org'" [singular]="true"></naming-convention-label>
            :
        </label>
        <div class="inputs-group-row-value">
            <p-dropdown
                [(ngModel)]="newOrganization"
                [options]="organizationsOptions"
                appendTo="body"
                placeholder="Select {{ namingConvService.organisationSingular }}">
            </p-dropdown>
        </div>
    </div>
    <div class="buttons-panel buttons-panel-top-margin">
        <button pButton type="button" label="Cancel" class="p-button-secondary"
                (click)="displayAddOrganization = false"></button>
        <button
            pButton
            type="button"
            label="Link {{ namingConvService.organisationSingular }}"
            [disabled]="newOrganization === null"
            (click)="addOrganization()"></button>
    </div>
</p-dialog>
